var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 10.3336C14.4 10.7752 14.04 11.2 13.5984 11.2H12.8V4.736C12.8 3.8512 12.0808 3.2 11.196 3.2H4.8V2.3336C4.8 1.892 5.1568 1.6 5.5984 1.6H13.5984C14.04 1.6 14.4 1.892 14.4 2.3336V10.3336ZM11.2 13.6C11.2 14.0416 10.8416 14.4 10.4 14.4H2.4C1.9584 14.4 1.6 14.0416 1.6 13.6V5.6C1.6 5.1576 1.9584 4.8 2.4 4.8H10.4C10.8416 4.8 11.2 5.1576 11.2 5.6V13.6ZM14.396 0H4.8016C3.916 0 3.2 0.6512 3.2 1.536V3.2H1.6016C0.716001 3.2 0 3.8512 0 4.736V14.3312C0 15.216 0.716001 16 1.6016 16H11.196C12.0808 16 12.8 15.216 12.8 14.3312V12.8H14.396C15.2808 12.8 16 12.016 16 11.1312V1.536C16 0.6512 15.2808 0 14.396 0Z",
    fill: "#3B414D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9617680bf623c746d5c8ae95bcd58804.svg";
export { ForwardRef as ReactComponent };